import { configureStore } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';

import { dataApi } from '@services';

import { queryErrorLogger } from './middlewares';
import {
  userSliceReducer,
  betSystemSliceReducer,
  vipSystemSliceReducer,
  referralUserProgressSliceReducer,
  telegramChatSliceReducer,
  popoverSliceReducer,
  ticketSliceReducer,
} from './slices';

enableMapSet();

export const store = configureStore({
  reducer: {
    [dataApi.reducerPath]: dataApi.reducer,
    userSliceReducer,
    betSystemSliceReducer,
    vipSystemSliceReducer,
    telegramChatSliceReducer,
    popoverSliceReducer,
    referralUserProgressSliceReducer,
    ticketSliceReducer,
  },
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(dataApi.middleware).concat(queryErrorLogger),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
